export enum AnswerMatchType {
  /**
   * å®å¨ä¸è´
   */
  EXACTLY = 'EXACTLY',
  /**
   * ä»é¡ºåºä¸ä¸è´
   */
  EXACTLY_IN_ANY_ORDER = 'EXACTLY_IN_ANY_ORDER',
  /**
   * ä»ä¾åè
   */
  ONLY_PREFERENCE = 'ONLY_PREFERENCE'
}
